import React, { useCallback } from 'react';

import { ButtonItem } from '@atlaskit/menu';
import { useAnalyticsEvents } from '@atlaskit/analytics-next';

import type { Agent } from '@atlassian/conversation-assistant-service';

import { AgentPresenceAvatar } from './AgentPresenceAvatar';

export type AgentPresenceMenuItemProps = {
	agent: Agent;
};

export const AgentPresenceMenuItem = ({ agent }: AgentPresenceMenuItemProps) => {
	const { createAnalyticsEvent } = useAnalyticsEvents();

	const handleAgentClick = useCallback(
		(agentId: string) => {
			createAnalyticsEvent({
				type: 'sendUIEvent',
				data: {
					source: 'aiAgentPresenceGroupOverflowMenu',
					action: 'clicked',
					actionSubject: 'button',
					actionSubjectId: 'aiAgentPresenceGroupOverflowMenuItem',
					product: 'confluence',
					attributes: {
						agentId,
					},
				},
			}).fire();
		},
		[createAnalyticsEvent],
	);

	return (
		<ButtonItem
			key={agent.id}
			onClick={() => handleAgentClick(agent.id)}
			iconBefore={<AgentPresenceAvatar agent={agent} />}
		>
			{agent.name}
		</ButtonItem>
	);
};
